module.exports = __webpack_public_path__ + "img/dog-icon.ed93ab00.svg";